import { statementTypes } from "./actions";

const initialState = {
  statementsList: [],
};

export function statementsReducer(state = initialState, actions) {
  const { type, payload } = actions;

  switch (type) {
    case statementTypes.SET_DATA:
      return {
        ...state,
        statementsList: payload,
      };

    case statementTypes.UPDATE_DATA:
      const index = state.statementsList.findIndex((item) => item.id === payload.id);
      const myState = [...state.statementsList];
      myState.splice(index, 1, payload);
      return {
        ...state,
        statementsList: [...myState],
      };

    default:
      return state;
  }
}
